export const es = (v) => (typeof v === "string" ? v : v && v.es ? v.es : "");

export const serif = { fontFamily: "'Cormorant Garamond', 'Playfair Display', serif" };
export const mont = { fontFamily: "Montserrat, sans-serif" };
export const body = { fontFamily: "Manrope, sans-serif" };

export const COLORS = {
  bg: "#FBF9F5",
  surface: "#FFFFFF",
  ink: "#121217",
  sec: "#52525B",
  mut: "#8E8E93",
  border: "#E8E4DC",
  green: "#1E5846",
  gold: "#D8963E",
};
